import React from "react";
import { useRef } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import formulaimg from "../../assets/RMDA_Hero_Formula.svg";
import Home2 from "./Home2";
import Home_bottom from "./Home_bottom";
import Type from "./Type";
import Home_timeline from "./Home_timeline";
import Home_feaproj from "./Home_feaproj";
import Home_feablog from "./Home_feablog";

function Home() {
    const containerRef = useRef(null);
    return (
      <section>
        <Container fluid  >
          <Container className="home-content">
            <Row>
              <Col md={4} className="home-header">
                <h1 style={{ paddingBottom: 15 }} className="heading">
                  Hello!{" "}
                  <span className="wave" role="img" aria-labelledby="wave">
                    👋🏻
                  </span>
                </h1>
  
                <h1 className="heading-name">
                  I'm
                  <strong className="main-name"> David Lee</strong>
                </h1>
  
                <div style={{ padding: 50, textAlign: "left" }}>
                  <Type />
                </div>
              </Col>
  
              <Col md={8} style={{ paddingBottom: 40 }}>
              <div style={{ height: "400px", width: "100%", overflow: "hidden" }}>
              <img
                src={formulaimg}
                alt="home pic"
                className="img-fluid"
                style={{ 
                  maxHeight: "600px", 
                  width: "100%",
                  marginTop: "-20px",
                  marginLeft: "20px",
                }}
              />
              </div>
              </Col>
            </Row>
          </Container>
        </Container>
        <Home2 />
        <Home_timeline />
        <Home_feaproj />
        <Home_feablog />
        <Home_bottom />
      </section>
    );
  }
  
  export default Home;